import { useDetectDevice } from 'hooks/useDetectDevice';
import useEvent from 'hooks/useEvent';
import { isEmpty, isFunction } from 'lodash';
import React, { useEffect } from 'react';

export const MOBILE_VIEW_FULL_SCREEN = 'fullScreen';
export const MOBILE_VIEW_MODAL = 'modal';

const withLoadEvent = (Component) => {
  const LoadEventComponent = (props) => {
    const { isDesktop } = useDetectDevice();

    const {
      screenId,
      onlineRef = '',
      senderId = '',
      isCheckEventEligible,
      isForceToCheckEventEligible,
      mobileViewInitial = '', // MOBILE_VIEW_FULL_SCREEN || MOBILE_VIEW_MODAL
      isSkip = false,
      action1Name = '',
      action2Name = '',
      isFullScreenWithHeader = false,
    } = props || {};

    const params = [
      ...(!isEmpty(onlineRef)
        ? [
            {
              key: 'onlineRef',
              value: onlineRef,
            },
          ]
        : []),
      ...(!isEmpty(senderId)
        ? [
            {
              key: 'senderId',
              value: senderId,
            },
          ]
        : []),
    ];
    const modalStyles = {
      width: isDesktop && 436,
      ...(mobileViewInitial === MOBILE_VIEW_FULL_SCREEN
        ? {
            maxHeight: isDesktop && '750px',
            borderRadius: isDesktop ? 20 : 0,
          }
        : {
            borderRadius: 20,
          }),
    };
    const modalOptions = {
      // iframeSrc: 'http://localhost:5173/100-daily-voucher/index.html',
      isCheckEventEligible,
      mobileViewInitial,
      isFullScreenWithHeader,
      ...(action1Name && {
        action1Name,
      }),
      ...(action2Name && {
        action2Name,
      }),
    };

    const { isShowEvent, showEventModal } = useEvent({
      screenId,
      params,
      modalStyles,
      modalOptions,
      isForceToCheckEventEligible,
    });
    useEffect(() => {
      if (isSkip) return;
      if (!isShowEvent) return;
      if (isFunction(showEventModal)) {
        showEventModal();
      }
    }, [isShowEvent, isSkip]);

    const newProps = {
      ...props,
    };
    return <Component {...newProps} />;
  };
  return LoadEventComponent;
};

export default withLoadEvent;
